import filter from 'lodash/filter'
import { server, auth, toastr } from '@/services/'

const state = {
  isFetching: false,
  isPosting: false,
  isPostingReservation: false,
  steps: 1,
  assignments: [],
  zones: [],
  stations: [],
  cars: [],
  carInStations: [],
  availableCars: [],
  reservationId: [],
  selectedStation: {}
}

const mutations = {
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setIsPosting (state, payload) {
    state.isPosting = payload
  },
  setIsPostingReservation (state, payload) {
    state.isPostingReservation = payload
  },
  setAssignments (state, payload) {
    state.assignments = payload
  },
  setZones (state, payload) {
    state.zones = payload
  },
  setStations (state, payload) {
    state.stations = payload
  },
  setCars (state, payload) {
    state.cars = payload
  },
  setCarInStations (state, payload) {
    state.carInStations = payload
  },
  setSteps (state, payload) {
    state.steps = payload
  },
  setUnlockStatus (state, payload) {
    let car = state.availableCars.find(car => car.CODE === payload.carCode)
    car.UNLOCK = payload.unlock
  },
  setAvailableCars (state, stationCode) {
    let filteredCars = state.cars.filter(car => car.STATION_CODE === stationCode)
    state.availableCars = filteredCars.map(obj => ({...obj, UNLOCK: false, EXTERIOR: false, INTERIOR: false, BOOT: false}))
  },
  setBookingStatus (state, payload) {
    let car = state.availableCars.find(car => car.CODE === payload.carCode)
    car.IS_BOOKED = payload.isBooked
    car.NOTE = payload.note
  },
  removeSubmittedCar (state, idx) {
    state.availableCars.splice(idx, 1)
  },
  setCarChecklist (state, payload) {
    let car = state.availableCars.find(car => car.CODE === payload.carCode)
    car[payload.attr] = payload.status
  },
  setCarMileage (state, payload) {
    let car = state.availableCars.find(car => car.CODE === payload.carCode)
    car.MILEAGE = payload.value
  },
  setReservationId (state, payload) {
    state.reservationId.push(payload)
  },
  resetCar (state, payload) {
    let car = state.availableCars.find(car => car.CODE === payload.carCode)
    car.INTERIOR = false
    car.EXTERIOR = false
    car.BOOT = false
    car.MILEAGE = state.cars.find(car => car.CODE === payload.carCode).MILEAGE
  },
  setSelectedStation (state, payload) {
    state.selectedStation = payload
    localStorage.setItem('selectedStation', JSON.stringify(payload))
  }
}

const actions = {
  fetchAssignments ({commit}) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getCleanerAssignments_byUACode/jwtCode').then(
        resp => {
          // set USAC on user cookies
          let user = auth.getUser()
          if (resp.data.msgContent.data.length) {
            user['USER_ACCOUNT_CODE'] = resp.data.msgContent.data[0].USER_ACCOUNT_CODE
          } else {
            user['USER_ACCOUNT_CODE'] = ''
          }
          auth.setUser(user)

          commit('setAssignments',filter(resp.data.msgContent.data, {STATUS: 1}))
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchZones ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getZones').then(
        resp => {
          let zones = resp.data.msgContent.data
          commit('setZones', zones)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getStations').then(
        resp => {
          let stations = resp.data.msgContent.data
          commit('setStations', stations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCars ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCars', { ACTIVE: true }).then(
        resp => {
          commit('setCars', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCarInStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCarInStations', { ACTIVE: true }).then(
        resp => {
          let carInStations = resp.data.msgContent.data
          commit('setCarInStations', carInStations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  filterStationsAndCars ({commit, state}) {
    // only show stations and cars that assigned to logged in user
    let carInStations = state.carInStations.filter(obj => {
      let tmp = state.assignments.find(assignment => assignment.CAR_IN_STATION_CODE === obj.CODE)
      if (tmp) {
        return obj
      }
    })
    let stations = state.stations.filter(obj => {
      let tmp = carInStations.find(cist => cist.STATION_CODE === obj.CODE)
      if (tmp) {
        return obj
      }
    })
    let cars = state.cars.filter(obj => {
      let tmp = carInStations.find(cist => cist.CAR_CODE === obj.CODE)
      if (tmp) {
        let assignment = state.assignments.find(assignment => assignment.CAR_IN_STATION_CODE === tmp.CODE)
        if (assignment) {
          Object.assign(obj, {STATION_CODE: tmp.STATION_CODE, CIST_CODE: tmp.CODE, NOTE: assignment.NOTE})
          return obj
        }
      }
    })
    commit('setStations', stations)
    commit('setCars', cars)
  },
  saveCleaningLog ({commit}, payload) {
    return new Promise((resolve, reject) => {
      server.post('/ops/insertCleaningLogs', payload).then(
        () => {
          toastr.success()
          commit('setIsPosting', false)
          resolve()
        },
        err => {
          commit('setIsPosting', false)
          reject(err)
        }
      )
    })
  },
  uploadImage ({commit}, payload) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('image', payload)
      server.post('/sso/fileUpload/Pic_CL', formData).then(
        resp => {
          resolve(resp.data.msgContent.fileUrl)
        },
        err => {
          toastr.serverError()
          commit('setIsPosting', false)
          reject(err)
        }
      )
    })
  },
  /* eslint-disable no-unused-vars */
  lockUnlockCar ({commit}, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/setLockUnlockCar', payload).then(
        resp => {
          resolve(resp)
        },
        err => {
          reject(err)
        }
      )
    })
  },
  createReservation ({commit}, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/createReservation', payload).then(
        resp => {
          if (resp.data.msgContent.reservationId === null || !resp.data.msgContent.reservationId) {
            toastr.error(`Failed to create reservation for ${payload.licensePlate}.`)
            resolve(true)
          } else {
            commit('setReservationId', {licensePlate: payload.licensePlate, reservationId: resp.data.msgContent.reservationId || ''})
            toastr.info(`Reservation created for ${payload.licensePlate}.`)
            resolve(true)
          }
        },
        () => {
          reject({licensePlate: payload.licensePlate, status: false})
        }
      )
    })
  },
  cancelReservation ({commit, state}, licensePlate) {
    let reservationId = state.reservationId.find(obj => obj.licensePlate === licensePlate)

    if (!reservationId) {
      return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/cancelReservation', {reservationId: reservationId.reservationId}).then(
        () => {
          commit('setReservationId', {})
          resolve(true)
        },
        err => reject(err)
      )
    })
  }
}

const getters = {
  getCarsByStation: (state) => (stationCode) => {
    return state.cars.filter(car => car.STATION_CODE === stationCode)
  },
  getUnlockedCars: state => {
    return state.availableCars.filter(car => car.UNLOCK === true)
  },
  getStationByCode: (state) => (stationCode) => {
    return state.stations.find(station => station.CODE === stationCode)
  },
  getCarByCode: (state) => (carCode) => {
    return state.cars.find(car => car.CODE === carCode)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
